<template>
  <div v-if="!hideConditionalMenu">
    <v-checkbox
      label="Make Conditional"
      v-model="node.meta['condition-type']"
    ></v-checkbox>
    <div v-if="node.meta['condition-type']" class="d-flex flex-column">
      <deciderNodeSelector
        @setdecidernodeid="setDeciderNode($event)"
        :selectedRecord="selectedRecord"
        :decidernode="node.meta['condition-node']"
      />
      <div v-if="node.meta['condition-node']">
        <div
          v-for="(condition, index) in numberOfConditions"
          :key="index"
          class="flex-grow-1"
        >
          <span class="flex-grow-1 d-flex flex-row">
            <v-btn
              class="ml-2"
              icon
              @click="removeCondition(condition)"
              color="red lighten-3"
            >
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <span class="flex-grow-1" v-if="conditionalType">
              <component
                :is="conditionalType"
                :node="node"
                :parentNodeId="parentNodeId"
                :parentNodeName="parentRecord.name"
                :selectedRecord="selectedRecord"
                :parentRecord="parentRecord"
                :index="index"
                :prexistingCondition="
                  prexistingConditionOptions.valueArray[index]
                "
                v-on:setCondition="conditionHandler($event)"
              />
            </span>
          </span>
          <div
            v-if="
              numberOfConditions.length > 1 &&
                index + 1 < numberOfConditions.length
            "
            class="d-flex justify-center"
          >
            <v-select
              :items="conditionChainOptions"
              v-model="prexistingConditionOptions.conditionChainOptions[index]"
              @change="setConditionChain($event, index)"
              class="d-inline-block flex-grow-0"
            ></v-select>
          </div>
        </div>
        <v-btn text small @click="addAnotherCondition()">
          <v-icon>mdi-plus</v-icon>
          Add another condition
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { rebuildConditionalStatement } from "../../../../utils/conditionalParser";
import deciderNodeSelector from "./deciderNodeSelector.vue";
import valueList from "./conditional-form-types/value-list";
import numeric from "./conditional-form-types/numeric";
import textType from "./conditional-form-types/text";
import title from "./conditional-form-types/title";
import boolean from "./conditional-form-types/boolean";
import multipleValueList from "./conditional-form-types/multiple-value-list";
import error from "./conditional-form-types/error.vue";
export default {
  props: {
    node: Object,
    parentNodeId: String,
    selectedRecord: Object
  },
  components: {
    deciderNodeSelector,
    valueList,
    numeric,
    textType,
    boolean,
    multipleValueList,
    title,
    error
  },
  computed: {
    conditionalType: function() {
      if (this.parentRecord) {
        switch (this.parentRecord.meta.type) {
          case "title":
            return title;
          case "boolean":
            return boolean;
          case "value-list":
            return valueList;
          case "multiple-value-list":
            return multipleValueList;
          case "text":
            return textType;

          case "numeric":
            return numeric;
          case "numeric-scale":
            return numeric;
          default:
            return null;
        }
      } else {
        return null;
      }
    },
    conditionAndConditionChain: function() {
      // this is a hack for vue v2.6 to get the watch to run whenever the following are updated
      return this.condition, this.conditionChain, this.key, Date.now();
    }
  },
  watch: {
    conditionAndConditionChain() {
      let conditionHolder = [];
      for (let x = 0; x < this.condition.length; x++) {
        conditionHolder.push(`value=${this.condition[x]}`);
        if (this.conditionChain) {
          conditionHolder.push(this.conditionChain[x]);
        }
      }
      conditionHolder = conditionHolder.join(" ").trim();
      this.node.meta.condition = conditionHolder;
    }
  },

  data() {
    return {
      hideConditionalMenu: false,
      parentRecord: false,
      conditionCounter: 1,
      numberOfConditions: [0],
      conditionChainOptions: ["and", "or"],
      condition: [],
      conditionChain: [],
      key: 0,
      prexistingConditionOptions: {
        valueArray: [
          "0",
          "1",
          "2",
          "3",
          " 4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          " 15"
        ],
        conditionChainOptions: [
          "0",
          "1",
          "2",
          "3",
          " 4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          " 15"
        ],
        conditionalTypeHolder: {}
      }
    };
  },
  methods: {
    ...mapActions(["getRecordItemOnDemand"]),
    setDeciderNode($event) {
      if ($event) {
        this.node.meta["condition-node"] = $event;
        this.getRecordItemOnDemand({
          recorditemid: $event,
          recordid: this.selectedRecord._id
        }).then(record => {
          this.parentRecord = record;
          if (this.node.meta.condition) {
            this.prexistingConditionOptions = rebuildConditionalStatement(
              this.node.meta.condition
            );
            //check for prexisting condition
            if (this.node.meta.condition) {
              //setup number of conditions
              this.numberOfConditions = [];
              for (
                let x = 0;
                x < this.prexistingConditionOptions.valueArray.length;
                x++
              ) {
                this.numberOfConditions.push(x);
              }
              //set conditional chain options
              this.conditionChain = this.prexistingConditionOptions.conditionChainOptions;
            }
          }
        });
      }
    },

    addAnotherCondition() {
      this.numberOfConditions.push(this.conditionCounter);
      this.conditionCounter++;
    },
    conditionHandler(conditionObject) {
      if (conditionObject.conditionevaltype === "contains") {
        this.evaltypehandler("contains");
      } else {
        this.evaltypehandler("equals");
      }
      this.key++;

      this.condition[conditionObject.index] = `${conditionObject.condition}`;
    },
    evaltypehandler(evaltype) {
      this.node.meta.evaltype = evaltype;
    },
    setConditionChain(condition, index) {
      this.key++;
      this.conditionChain[index] = condition;
    },
    removeCondition(condition) {
      this.$delete(
        this.numberOfConditions,
        this.numberOfConditions[this.numberOfConditions.indexOf(condition)]
      );
    }
  }
};
</script>

<style></style>
